import { Constants, ApplicationState, ApplicationActionTypes } from './types'

const initialState: ApplicationState = {
  list: [],
  current: null,
}

export function applicationReducer(
  state = initialState,
  action: ApplicationActionTypes,
): ApplicationState {
  switch (action.type) {
    case Constants.SET_APPLICATIONS:
      return {
        ...state,
        list: action.payload,
      }
    case Constants.SET_CURRENT:
      return {
        ...state,
        current: action.payload,
      }
    default:
      return state
  }
}

export default applicationReducer
